import { render } from "./AttendanceIpSettings.vue?vue&type=template&id=12f78cd6"
import script from "./AttendanceIpSettings.vue?vue&type=script&lang=js"
export * from "./AttendanceIpSettings.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__